var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTelefone(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M31.9999 0C14.3281 0 0 14.3282 0 32C0 49.6716 14.3281 64 31.9999 64C49.6717 64 63.9996 49.6714 63.9996 32C63.9997 14.3282 49.6717 0 31.9999 0ZM48.898 46.6915L46.3358 49.2542C45.8784 49.711 44.5389 49.9961 44.4959 49.9961C36.3904 50.0668 28.5859 46.8829 22.8517 41.1481C17.1017 35.3949 13.9142 27.5626 13.9998 19.4297C13.9998 19.426 14.2932 18.1249 14.7502 17.6722L17.3122 15.1098C18.2498 14.1679 20.0508 13.7422 21.3124 14.1643L21.8513 14.3441C23.1093 14.7658 24.43 16.1567 24.7776 17.4381L26.0664 22.1684C26.4139 23.4535 25.9452 25.2817 25.0079 26.2193L23.2971 27.9303C24.9767 34.1484 29.8556 39.0282 36.0747 40.7119L37.7848 39.0005C38.7267 38.0586 40.5544 37.5902 41.8367 37.9373L46.5663 39.2307C47.8479 39.5829 49.2386 40.8953 49.6601 42.1528L49.8399 42.6996C50.2578 43.9576 49.8354 45.7582 48.898 46.6915Z",
    fill: "#B850F9"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTelefone);
export default __webpack_public_path__ + "static/media/telefone.4259f53b25f929ce7ab15ab44e6701fa.svg";
export { ForwardRef as ReactComponent };